 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","account~findpwd~findpwd_h5~login~login_h5~signup_h5":"account~findpwd~findpwd_h5~login~login_h5~signup_h5","login":"login","login_h5":"login_h5","signup_h5":"signup_h5","active":"active","apple_return_url":"apple_return_url","account":"account","findpwd":"findpwd","findpwd_h5":"findpwd_h5","paygame":"paygame","gamelist_h5":"gamelist_h5","home":"home","news":"news","siteinfo":"siteinfo","siteinfoH5":"siteinfoH5","terms":"terms","termsH5":"termsH5","tokusyouhou":"tokusyouhou","tokusyouhouH5":"tokusyouhouH5"}[chunkId]||chunkId) + "." + {"about":"bed6612d","account~findpwd~findpwd_h5~login~login_h5~signup_h5":"0555236f","login":"e1621e3a","login_h5":"6b9a9e91","signup_h5":"3ca3b49d","active":"cd188d19","apple_return_url":"07367cb4","chunk-10504389":"185c94c3","chunk-3258cec9":"a4b5b852","chunk-c9e50002":"7324f001","chunk-55d92bc1":"4550dd28","account":"31e64cde","findpwd":"d2791545","findpwd_h5":"f8ab2b47","chunk-410cceab":"74bb6b4a","chunk-05140ea4":"a5f2a137","chunk-53b1a546":"9bea3dcf","chunk-5c8c8396":"8a5f5ebd","paygame":"fac47162","chunk-cf21638c":"050d2639","chunk-d2d30040":"5fed3052","chunk-44416384":"3d7da340","chunk-528af5cf":"72d8dc5e","chunk-6b565d8e":"57746e2f","chunk-6100cc29":"064c42a5","chunk-72fded8b":"c350b31e","chunk-cfe54dde":"8b76bb8a","chunk-e665f460":"f19f2a62","gamelist_h5":"a73de9a1","home":"e5783f0f","news":"27062d56","siteinfo":"90ccda95","siteinfoH5":"4791953a","terms":"0131c2cc","termsH5":"e42326e0","tokusyouhou":"c7af511e","tokusyouhouH5":"745d50c3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"login":1,"login_h5":1,"signup_h5":1,"active":1,"chunk-10504389":1,"chunk-3258cec9":1,"chunk-c9e50002":1,"chunk-55d92bc1":1,"account":1,"findpwd":1,"findpwd_h5":1,"chunk-410cceab":1,"chunk-05140ea4":1,"chunk-53b1a546":1,"chunk-5c8c8396":1,"paygame":1,"chunk-cf21638c":1,"chunk-d2d30040":1,"chunk-44416384":1,"chunk-528af5cf":1,"chunk-6b565d8e":1,"chunk-6100cc29":1,"chunk-72fded8b":1,"chunk-cfe54dde":1,"chunk-e665f460":1,"gamelist_h5":1,"home":1,"news":1,"terms":1,"termsH5":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","account~findpwd~findpwd_h5~login~login_h5~signup_h5":"account~findpwd~findpwd_h5~login~login_h5~signup_h5","login":"login","login_h5":"login_h5","signup_h5":"signup_h5","active":"active","apple_return_url":"apple_return_url","account":"account","findpwd":"findpwd","findpwd_h5":"findpwd_h5","paygame":"paygame","gamelist_h5":"gamelist_h5","home":"home","news":"news","siteinfo":"siteinfo","siteinfoH5":"siteinfoH5","terms":"terms","termsH5":"termsH5","tokusyouhou":"tokusyouhou","tokusyouhouH5":"tokusyouhouH5"}[chunkId]||chunkId) + "." + {"about":"a09001c8","account~findpwd~findpwd_h5~login~login_h5~signup_h5":"31d6cfe0","login":"d9defe07","login_h5":"d40e30af","signup_h5":"c7127888","active":"4f35a5fe","apple_return_url":"31d6cfe0","chunk-10504389":"0f989792","chunk-3258cec9":"af8cb93e","chunk-c9e50002":"cd540b09","chunk-55d92bc1":"4e422529","account":"74f8b5c0","findpwd":"c8c80421","findpwd_h5":"73a42c64","chunk-410cceab":"6cc7c9a5","chunk-05140ea4":"3ff4595b","chunk-53b1a546":"79c08cea","chunk-5c8c8396":"ba622651","paygame":"0aad1756","chunk-cf21638c":"77974a1a","chunk-d2d30040":"4e56309c","chunk-44416384":"5c458c1a","chunk-528af5cf":"2343a693","chunk-6b565d8e":"79f6c340","chunk-6100cc29":"e23804cc","chunk-72fded8b":"c7213235","chunk-cfe54dde":"43df6e23","chunk-e665f460":"d534cdbe","gamelist_h5":"ca7f5fd3","home":"31326e30","news":"288f8443","siteinfo":"31d6cfe0","siteinfoH5":"31d6cfe0","terms":"bd66f714","termsH5":"7f2dc612","tokusyouhou":"31d6cfe0","tokusyouhouH5":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
